
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    texts: { type: Array },
    color: { type: String },
    isMobile: { type: Boolean },
    isOnline: { type: Boolean },
  },
});
